/* ulist.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import "./ulist.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
var listStyles = null;
var UList = function UList(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("ul", _extends({}, props, {
    className: ax(["_19bvv47k _bozgv47k"])
  }), children);
};
export default UList;